import { Action } from '@ngrx/store';

export const MENU_INIT = '[ORG_ADMIN_SETTINGS_MENU_INIT] Init';
export const MENU_SELECT = '[ORG_ADMIN_SETTINGS_MENU_SELECT] Select';
export const APPS_INIT = '[ORG_ADMIN_SETTINGS_APPS_INIT] Init';
export const APPS_SELECT = '[ORG_ADMIN_SETTINGS_APPS_SELECT] Select';
export const CONFIGURATION_INIT = '[ORG_ADMIN_SETTINGS_CONFIGURATION_INIT] Configuration init';

export class MenuSelect implements Action {
  readonly type = MENU_SELECT;

  constructor(public payload: string) { }
}

export class MenuInit implements Action {
  readonly type = MENU_INIT;

  constructor(public payload: any) { }
}

export class AppsInit implements Action {
  readonly type = APPS_INIT;

  constructor(public payload: any) { }
}

export class AppsSelect implements Action {
  readonly type = APPS_SELECT;

  constructor(public payload: any) { }
}

export class ConfigurationInit implements Action {
  readonly type = CONFIGURATION_INIT;

  constructor(public payload: any) { }
}

export type StoreAction = MenuSelect | MenuInit | AppsSelect | AppsInit | ConfigurationInit;
